import type { NavItem as NavItemType } from '../../types/dashboard.types';
import { NavItem } from './NavItem';

interface SidebarNavSectionProps {
  label: string;
  items: NavItemType[];
  isCollapsed: boolean;
}

export function SidebarNavSection({
  label,
  items,
  isCollapsed,
}: SidebarNavSectionProps) {
  return (
    <div className="flex flex-col gap-2">
      {!isCollapsed && (
        <span className="px-4 text-xs font-semibold uppercase tracking-wider text-foreground-inverse/50">
          {label}
        </span>
      )}
      {items.map((item) => (
        <NavItem key={item.key} item={item} isCollapsed={isCollapsed} />
      ))}
    </div>
  );
}
